/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import Select from "react-select";
import {
  Button,
  ButtonToolbar,
  Modal,
  Table,
  Form,
  Col,
} from "react-bootstrap";
import swal from "sweetalert";
import { NoticeManajemenUser } from "../../../../_metronic/_partials/controls";
import { Link, useHistory } from "react-router-dom";
import AppConfig from "../../../config/AppConfig";

class PenugasanFaswil extends Component {
  constructor(props, context) {
    super(props, context);
    this.modalPengguna = this.modalPengguna.bind(this);
    this.closeModalPengguna = this.closeModalPengguna.bind(this);
  }
  state = {
    // ==================================
    loadingBtn: false,
    loadingForm: true,
    loadingList: true,
    loadingDetails: true,
    loadingModals: true,
    modalPengguna: false,
    // ====
    dataPenugasan: [],
    ref_lingkup: [],
    lingkup_koordinasi: "",
    id_pengguna: "",
    nm_pengguna: "",
    loadingPengguna: false,
    displayPengguna: false,
    displaySP: false,
    loadingSP: false,
    keySP: 0,
    dataPengguna: [],
    listPengguna: [],
  };

  onInputForm = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  closeModalPengguna() {
    this.setState({
      modalPengguna: false,
    });
  }

  modalPengguna = (id) => {
    this.setState({ modalPengguna: true, loadingModals: true });

    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    var formData = new FormData();
    formData.append("data[lingkup_koordinasi]", id);
    formData.append("data[id_bp]", sessiondata.i_idbp);

    axios.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";

    axios
      .post(AppConfig.ListPenggunaPenugasanFaswil + session, formData)
      .then((res) => {
        this.setState(
          {
            loadingModals: false,
            listPengguna: res.data.result.data,
          },
          () => {
            console.log(this.state.listPengguna);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  selectedLingkupKoordinasi = (val) => {
    this.setState({
      lingkup_koordinasi: val.value,
    });
  };

  componentDidMount() {
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    console.log(sessiondata);
    if (sessiondata.i_idrole === 2013) {
      window.history.back();
    }
    this.setState({ loadingForm: true });
    axios
      .get(AppConfig.AddPenugasanFaswil)
      .then((res) => {
        if (sessiondata.i_idrole === 2014) {
          this.setState({
            lingkup_koordinasi: sessiondata.i_idunit,
            lingkup_koordinasi_nama: sessiondata.i_nmunit,
          });
        }
        this.setState({
          loadingForm: false,
          ref_lingkup: res.data.result.ref_lingkup,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onChangePengguna = (e, id_pembina) => {
    this.setState({
      id_pengguna: "",
      nm_pengguna: e.target.value,
    });
    if (e.target.value.length > 2) {
      this.setState({
        displayPengguna: false,
        loadingPengguna: true,
      });

      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        session =
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          sessiondata.i_idunit +
          "&id_role=" +
          sessiondata.i_idrole;
      }

      var formData = new FormData();
      formData.append("data[lingkup_koordinasi]", id_pembina);
      formData.append("data[keyword]", e.target.value);
      formData.append("data[id_bp]", sessiondata.i_idbp);

      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded";
      axios
        .post(AppConfig.GetPenggunaPenugasanFaswil + session, formData)
        .then((res) => {
          if (res.status === 200) {
          }
          this.setState(
            {
              dataPengguna: res.data.result.data,
              displayPengguna: true,
              loadingPengguna: false,
            },
            () => {
              console.log(this.state.dataPengguna);
            }
          );
        })
        .catch((errors) => {
          console.log(errors);
        });
    } else {
      this.setState({
        displayPengguna: false,
      });
    }
  };

  onClickSelectPengguna = (id_pengguna, nm_pengguna) => {
    this.setState({
      id_pengguna: id_pengguna,
      nm_pengguna: nm_pengguna,
      displayPengguna: false,
    });
  };

  showAddFormSP() {
    let dataSP = {
      id_pengguna: this.state.id_pengguna,
      id_organisasi: this.state.lingkup_koordinasi,
      id_sp: "",
      nama_sp: "",
      statusok: false,
    };
    this.state.dataPenugasan.push(dataSP);
    this.setState({
      dataSP: [],
    });
  }

  onChangeSP = (e, id_pembina, key) => {
    this.state.dataPenugasan[key].id_sp = "";
    this.state.dataPenugasan[key].nama_sp = e.target.value;

    if (e.target.value.length > 2) {
      this.setState({
        displaySP: false,
        loadingSP: true,
      });

      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        session =
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          sessiondata.i_idunit +
          "&id_role=" +
          sessiondata.i_idrole;
      }

      var formData = new FormData();
      formData.append("data[id_pembina]", id_pembina);
      formData.append("data[id_bp]", sessiondata.i_idbp);
      formData.append("data[keyword]", e.target.value);

      axios.defaults.headers.post["Content-Type"] =
        "application/x-www-form-urlencoded";
      axios
        .post(AppConfig.GetPTPenugasanFaswil + session, formData)
        .then((res) => {
          if (res.status === 200) {
          }
          this.setState({
            dataSP: res.data.result.data,
            displaySP: true,
            loadingSP: false,
            keySP: key,
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    } else {
      this.setState({
        displaySP: false,
      });
    }
  };
  onClickSelectSP = (id_sp, nama_sp) => {
    this.state.dataPenugasan[this.state.keySP].id_sp = id_sp;
    this.state.dataPenugasan[this.state.keySP].nama_sp = nama_sp;
    this.state.dataPenugasan[this.state.keySP].statusok = true;
    this.setState({
      displaySP: false,
    });
  };

  deletePTPenugasan(key) {
    console.log(key);
    var array = [...this.state.dataPenugasan]; // make a separate copy of the array
    var index = array.indexOf(this.state.dataPenugasan[key]);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ dataPenugasan: array });
    }
    console.log(this.state.dataPenugasan);
  }
  handleSave = (e) => {
    e.preventDefault();
    const { dataPenugasan } = this.state;
    this.setState({ loadingBtn: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+`
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    var formData = new FormData();
    formData.append("data[penugasan]", JSON.stringify(dataPenugasan));
    axios
      .post(AppConfig.SavePenugasanFaswil + session, formData)
      .then((res) => {
        this.setState({
          loadingBtn: false,
        });
        if (res.data.status === "sukses") {
          swal({
            title: "Sukses!",
            text: "Data penugasan berhasil disimpan!",
            icon: "success",
            button: "OK!",
          }).then(() => {
            window.history.back();
          });
        } else {
          swal({
            title: "Gagal!",
            text: "Gagal menyimpan data!",
            icon: "error",
            button: "OK!",
          });
        }
      })
      .catch((err) => {
        swal({
          title: "Gagal!",
          text: "Gagal menyimpan data!",
          icon: "error",
          button: "OK!",
        });
        console.log(err);
      });
  };

  // Layout ============================================================================
  render() {
    // console.log(this.state.lingkup_koordinasi);
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));

    const { ref_lingkup, lingkup_koordinasi, dataPenugasan } = this.state;

    var i = 0;
    let result_ref = [];
    for (var key in ref_lingkup) {
      result_ref[i] = {
        value: key,
        label: ref_lingkup[key],
      };
      i++;
    }

    let loadPengguna = <></>;
    if (this.state.loadingPengguna === true) {
      loadPengguna = (
        <i
          className="ml-3 spinner spinner-black"
          style={{
            position: "absolute",
            zIndex: 2,
            right: "45px",
            bottom: "20px",
          }}
        ></i>
      );
    }

    let listPenggunaPenugasan = <></>;
    if (this.state.displayPengguna === true) {
      if (this.state.dataPengguna.length > 0) {
        let dataPengguna = [];
        this.state.dataPengguna.map((v, i) => {
          dataPengguna.push(
            <div
              onClick={(e) =>
                this.onClickSelectPengguna(v.id_pengguna, v.nm_pengguna)
              }
              style={{
                background: "#fff",
                padding: "10px",
                color: "#2c2c2c",
                borderBottom: "1px solid #ccc",
                cursor: "pointer",
              }}
            >
              {v.nm_pengguna} {v.username !== null ? "(" + v.username + ")" : ""}
            </div>
          );
        });
        listPenggunaPenugasan = (
          <div
            style={{
              position: "absolute",
              zIndex: "2",
              boxShadow: "0 4px 8px 0 rgb(0 0 0 / 15%)",
              width: "100%",
            }}
          >
            {dataPengguna}
          </div>
        );
      } else {
        listPenggunaPenugasan = (
          <div
            style={{
              position: "absolute",
              zIndex: "2",
              boxShadow: "0 4px 8px 0 rgb(0 0 0 / 15%)",
              background: "#fff",
              padding: "10px",
              color: "#ccc",
              borderBottom: "1px solid #ccc",
              cursor: "pointer",
              fontStyle: "italic",
            }}
          >
            Data user tidak ditemukan.
          </div>
        );
      }
    }

    let loadSP = <></>;
    if (this.state.loadingSP === true) {
      loadSP = (
        <i
          className="ml-3 spinner spinner-black"
          style={{
            position: "absolute",
            zIndex: 2,
            right: "25.5%",
            bottom: "40px",
          }}
        ></i>
      );
    }

    let listSPPenugasan = <></>;
    if (this.state.displaySP === true) {
      if (this.state.dataSP.length > 0) {
        let dataSp = [];
        this.state.dataSP.map((v, i) => {
          dataSp.push(
            <div
              onClick={(e) => this.onClickSelectSP(v.id_sp, v.nm_lemb)}
              style={{
                background: "#fff",
                padding: "10px",
                color: "#2c2c2c",
                borderBottom: "1px solid #ccc",
                cursor: "pointer",
              }}
            >
              {v.nm_lemb}
            </div>
          );
        });
        listSPPenugasan = (
          <div
            style={{
              position: "absolute",
              zIndex: "2",
              boxShadow: "0 4px 8px 0 rgb(0 0 0 / 15%)",
            }}
          >
            {dataSp}
          </div>
        );
      } else {
        listSPPenugasan = (
          <div
            style={{
              position: "absolute",
              zIndex: "2",
              boxShadow: "0 4px 8px 0 rgb(0 0 0 / 15%)",
              background: "#fff",
              padding: "10px",
              color: "#ccc",
              borderBottom: "1px solid #ccc",
              cursor: "pointer",
              fontStyle: "italic",
            }}
          >
            Data perguruan tinggi tidak ditemukan.
          </div>
        );
      }
    }

    return (
      <>
        <NoticeManajemenUser style={{ marginBottom: "0px", boxShadow: "none" }}>
          <strong style={{ fontSize: "18px" }}>Penugasan Fasilitator</strong>
          <p>Tambah Penugasan Fasilitator</p>
        </NoticeManajemenUser>
        <br />
        <Card style={{ padding: "2%" }} className="overflow-auto">
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <h2>Form Penambahan Penugasan Fasilitator</h2>
                </div>
              </div>
            </div>
          </div>
          <Form
            className="needs-validation"
            onSubmit={this.handleSave}
            noValidate
          >
            {this.state.loadingForm === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <Form.Row>
                  <Form.Group as={Col}>
                    <Form.Label>Lingkup Koordinasi</Form.Label>
                    {userdata.i_idrole !== 2014 ? (
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isSearchable={false}
                        autoFocus={false}
                        options={result_ref}
                        placeholder="Pilih Lingkup Koordinasi"
                        onChange={this.selectedLingkupKoordinasi}
                      />
                    ) : (
                      <>
                        <br />
                        <Form.Label>
                          <b>{userdata.i_nmunit}</b>
                        </Form.Label>
                      </>
                    )}
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label>User Pengguna</Form.Label>
                    <div className="row">
                      <div className="col-md-8">
                        {loadPengguna}
                        <Form.Control
                          type="text"
                          placeholder="Masukan keyword : Username / Nama Pengguna"
                          onChange={(e) =>
                            this.onChangePengguna(
                              e,
                              this.state.lingkup_koordinasi
                            )
                          }
                          autoComplete="off"
                          value={this.state.nm_pengguna}
                          disabled={this.state.lingkup_koordinasi === ""}
                        />
                        {listPenggunaPenugasan}
                      </div>
                      <div className="col-md-4">
                        <Button
                          variant="success"
                          style={{
                            padding: "10px",
                            width: "100%",
                          }}
                          onClick={() =>
                            this.modalPengguna(this.state.lingkup_koordinasi)
                          }
                          disabled={this.state.lingkup_koordinasi === ""}
                        >
                          <i
                            className="flaticon-user"
                            style={{ color: "#ffffff", fontSize: "14px" }}
                          ></i>
                          &nbsp; Lihat Daftar User Faswil
                        </Button>
                      </div>
                    </div>
                  </Form.Group>
                </Form.Row>
                {dataPenugasan.length <= 20 ? (
                  <div className="row mb-10">
                    <div className="offset-md-8"></div>
                    <div className="col-md-4 text-right">
                      <Button
                        variant="primary"
                        style={{
                          padding: "12px",
                          width: "50%",
                        }}
                        onClick={() => this.showAddFormSP()}
                        disabled={
                          this.state.lingkup_koordinasi === "" ||
                          this.state.id_pengguna === ""
                        }
                      >
                        <i
                          className="flaticon-add"
                          style={{ color: "#ffffff", fontSize: "14px" }}
                        ></i>
                        &nbsp; Tambah Perguruan Tinggi
                      </Button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="row">
                  <div className="col-md-12">
                    <Table responsive hover style={{ overflow: "auto" }}>
                      <thead
                        className="text-white"
                        style={{ backgroundColor: "#3047ad" }}
                      >
                        <tr>
                          <th
                            style={{
                              width: "80%",
                              fontSize: "12px",
                              textTransform: "uppercase",
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                          >
                            Perguruan Tinggi
                          </th>
                          <th
                            className="text-center"
                            style={{
                              width: "20%",
                              fontSize: "12px",
                              textTransform: "uppercase",
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                          >
                            Aksi
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataPenugasan.length > 0 ? (
                          dataPenugasan.map((list, key) => (
                            <tr>
                              <td
                                style={{ verticalAlign: "middle" }}
                                className="text-center"
                              >
                                <i
                                  className="flaticon-search text-dark"
                                  style={{
                                    position: "absolute",
                                    zIndex: 0,
                                    right: "22%",
                                    bottom: "28px",
                                  }}
                                ></i>
                                {loadSP}
                                <Form.Control
                                  type="text"
                                  placeholder="Masukan keyword : Nama perguruan tinggi.."
                                  onChange={(e) =>
                                    this.onChangeSP(
                                      e,
                                      this.state.lingkup_koordinasi,
                                      key
                                    )
                                  }
                                  autoComplete="off"
                                  value={this.state.dataPenugasan[key].nama_sp}
                                  disabled={
                                    this.state.dataPenugasan[key].statusok
                                  }
                                />
                                {this.state.dataPenugasan[key].statusok === false
                                  ? listSPPenugasan
                                  : ""}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                <Button
                                  onClick={() => this.deletePTPenugasan(key)}
                                  className="btn btn-icon btn-danger btn-sm"
                                  style={{
                                    minWidth: "50px",
                                    borderRadius: "12px",
                                  }}
                                >
                                  <i
                                    className="flaticon-delete"
                                    style={{
                                      color: "#FFFFFF",
                                      fontSize: "14px",
                                    }}
                                  ></i>
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <>
                            <td colSpan="5" style={{ textAlign: "center" }}>
                              <em>
                                Pilih lingkup koordinasi & user pengguna
                                terlebih dahulu
                              </em>
                            </td>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div style={{ float: "right", marginLeft: "10px" }}>
                      <ButtonToolbar>
                        <span className="svg-icon svg-icon-2x svg-icon-white">
                          <Button
                            disabled={
                              this.state.loadingBtn ||
                              this.state.dataPenugasan.length === 0
                            }
                            variant="primary"
                            type="submit"
                          >
                            Simpan
                            {this.state.loadingBtn && (
                              <i className="ml-2 mr-1 spinner spinner-white"></i>
                            )}
                            &nbsp;&nbsp;
                          </Button>
                        </span>
                      </ButtonToolbar>
                    </div>
                    <div style={{ float: "right" }}>
                      <ButtonToolbar>
                        <span className="svg-icon svg-icon-2x svg-icon-white">
                          <Link to="/penugasan-faswil">
                            <Button
                              variant="secondary"
                              disabled={this.state.loadingBtn}
                            >
                              Kembali
                            </Button>
                          </Link>
                        </span>
                      </ButtonToolbar>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Form>
        </Card>
        <Modal
          size="lg"
          show={this.state.modalPengguna}
          onHide={this.closeModalPengguna}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Daftar user fasilitator{" "}
              {this.state.loadingModals === false &&
              this.state.listPengguna.length > 0
                ? " di wilayah " + this.state.listPengguna[0].nm_lemb
                : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingModals === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <Table responsive style={{ overflow: "auto" }}>
                  <thead
                    className="text-white"
                    style={{ backgroundColor: "#3047ad" }}
                  >
                    <tr>
                      <th
                        style={{
                          width: "10%",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        No
                      </th>
                      <th
                        style={{
                          width: "90%",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        Nama Lengkap
                      </th>
                      <th
                        style={{
                          width: "90%",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        Username
                      </th>
                      <th
                        style={{
                          width: "90%",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        BP
                      </th>
                      <th
                        style={{
                          width: "90%",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                      >
                        HP
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.listPengguna.length > 0 ? (
                      this.state.listPengguna.map((list, key) => (
                        <tr>
                          <td
                            style={{
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                          >
                            {key + 1}
                          </td>
                          <td
                            style={{ verticalAlign: "middle" }}
                            className="text-center"
                          >
                            {list.nm_pengguna}
                          </td>
                          <td
                            style={{ verticalAlign: "middle" }}
                            className="text-center"
                          >
                            {list.username}
                          </td>
                          <td
                            style={{ verticalAlign: "middle" }}
                            className="text-center"
                          >
                            {list.id_bp === 2 ? "vokasi" : "akademik"}
                          </td>
                          <td
                            style={{ verticalAlign: "middle" }}
                            className="text-center"
                          >
                            {list.no_hp === "null" ? "-" : list.no_hp}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                          <em>Data does not exist</em>
                        </td>
                      </>
                    )}
                  </tbody>
                </Table>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalPengguna}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default PenugasanFaswil;
